import { StylesManager, Model } from 'survey-core';
import { Survey } from 'survey-vue-ui';
import Loader from "@/components/loader/Loader.vue";
import firebase from "firebase";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { serializer } from "@/api/shared/serializer";
import {getRegionName} from "@/utils/functionsRegion";
import { VisitorRoleEnum } from '@/enums/VisitorRoleEnum';
StylesManager.applyTheme("modern");

export default {
    name: "surveyForm",
    components: {
        Survey,
        Loader,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            loading: true,
            loadingForm: false,
            surveyform: this.surveyForm,
            surveyResult: null,
            dialog: false,
            isResident: true,
            preliminaryQuestions: {
                isHappy: "",
                isAssistant: true,
                assistantType: ""
            }
        };
    },
    computed: {
        survey() {
            return this.$store.state.surveyModule.currentSurvey;
        },
        surveyForm() {
            return this.$store.state.surveyModule.currentSurveyForm;
        }
    },
    async created() {
        const surveyId = this.$route.params.id;
        window.addEventListener("beforeunload", this.leaving);

        if (this.$route.name === "SurveyGuestbook") {
            await this.$store.dispatch("getSurvey", { id: surveyId, isRoute: false });
            await this.$store.dispatch("getSurveyForm", { id: surveyId });
            this.openPreliminaryQuestions();
            this.createSurveyForm();
            this.loading = false;
            return false;
        }

        if (this.$route.params?.token?.length) {
            await this.$store.dispatch("signInByCustomToken", { customToken: this.$route.params.token, isExternalPagesViewing: true })
            const premiumFeatures = this.$store.getters.premiumFeatures;
            if(premiumFeatures.isStaffHubSurveys === false){
                await this.$store.dispatch("userSignOut")
            }
       }

        if(this.$route.name === "SurveyEmail") {
            if(this.$route.params.visitorId && this.$route.params.visitorId?.length) {

                const claims: any = {}
                const role = this.$route.params?.visitorRole

                if(role === VisitorRoleEnum.FamilyMember){
                    claims.isFamily = true
                } else if (role === VisitorRoleEnum.Resident){
                    claims.isResident = true
                } else if (role === VisitorRoleEnum.Staff){
                    claims.isStaff = true
                }

                const superAdminCustomTokenResult = await firebase.app().functions(getRegionName()).httpsCallable("getUserCustomToken")({
                    userId: this.$route.params.visitorId,
                    userType: role,
                    claims: claims
                })
                const superAdminTokenCustomToken = superAdminCustomTokenResult?.data?.customToken;
                await this.$store.dispatch("signInByCustomToken", {  customToken: superAdminTokenCustomToken })
                await this.$store.dispatch("getSurvey", { id: surveyId, isRoute: false });
                await this.getExistSurveyResultDoc(surveyId, this.$route.params.visitorId);
                await this.$store.dispatch("getSurveyForm", { id: surveyId });
                this.openPreliminaryQuestions();
                this.createSurveyForm();
                return false;
            }
        }

        await this.$store.dispatch("getSurvey", { id: surveyId, isRoute: false });
        await this.getExistSurveyResultDoc(surveyId, this.$route.params.r);
        this.openPreliminaryQuestions();
        this.createSurveyForm();
        this.loading = false;
    },
    async beforeDestroy() {
        if(this.$store.getters?.user?.isExternalPagesViewing === true){
            await this.$store.dispatch("userSignOut")
        }
    },
    methods: {
        async leaving() {
            if(this.$store.getters?.user?.isExternalPagesViewing === true){
                await this.$store.dispatch("userSignOut")
            }
        },
        async saveSurveyResult(name, value) {
            if (["SurveyForm", "SurveyEmail"].includes(this.$route.name)) {
                await firebase
                    .firestore()
                    .collection("surveyResults")
                    .doc(this.surveyResult.id)
                    .get()
                    .then(doc => {
                        const surveyResult = doc.data().surveyResult;
                        surveyResult[name] = value;

                        const updates = {
                            surveyResult: surveyResult,
                            isCompletedByEmail: this.$route.name === "SurveyEmail"
                        };

                        doc.ref.update(updates);
                    });
            }
        },
        createSurveyResult(result) {
            if (this.$route.name == "SurveyGuestbook") {
                const survey = this.$route.params.id;
                const visitId = this.$route.params.visitId;
                const visitorId = this.$route.params.visitorId;
                this.$store.dispatch("submitGuestbookSurveyResult", {
                    surveyId: survey,
                    visitId: visitId,
                    visitorId: visitorId,
                    surveyResult: result,
                });
            } else {
                const survey = this.$route.params.id;
                this.$store.dispatch("submitSurveyResult", {
                    surveyId: survey,
                    id: this.surveyResult.id,
                    r: this.$route.params.r ?? this.$route.params.visitorId,
                    surveyResult: result
                });
            }
        },
        createSurveyForm() {
            const surveyForm = this.surveyForm;
            const surveyResult = this.surveyResult?.surveyResult;

            if (surveyForm) {
                const model = new Model(surveyForm);
                const createSurvey = this.createSurveyResult;
                const saveSurvey = this.saveSurveyResult;

                model.onValueChanging.add((result, { name, value }) => {
                    saveSurvey(name, value)
                })

                model.onComplete.add(function (result) {
                    createSurvey(result);
                });

                if (surveyResult && Object.keys(surveyResult).length) {
                    Object.entries(surveyResult).forEach(entry => {
                        const [key, value] = entry;
                        model.setValue(key, value);
                    });
                }

                this.surveyform = model;
            }

            this.loading = false
        },
        async getExistSurveyResultDoc(surveyId, r) {
            const { facilityId } = (await firebase.firestore().collection("surveys").doc(surveyId).get()).data()

            await firebase
                .firestore()
                .collection("surveyResults")
                .where("facilityId", "==", facilityId)
                .where("surveyId", "==", surveyId)
                .where("r", "==", r)
                .get()
                .then(async data => {
                    const surveyResult = serializer.querySnapshotToDocuments(data);

                    if (surveyResult.length) {
                        await this.$store.dispatch("getSurveyForm", { id: surveyId })
                        this.surveyResult = {
                            id: surveyResult[0].id,
                            ...surveyResult[0]
                        }
                    } else {

                        await firebase
                            .firestore()
                            .collection("surveyResults")
                            .add({
                                facilityId: facilityId,
                                surveyId: surveyId,
                                r: r,
                                surveyResult: {},
                                isCompleted: false,
                                submittedDateTime: new Date()
                            }).then(async data => {
                                this.surveyResult = { id: data.id };
                                await this.$store.dispatch("getSurveyForm", { id: surveyId })
                            })

                        await firebase
                            .firestore()
                            .collection("surveys")
                            .doc(surveyId)
                            .update({
                                'inProgress': firebase.firestore.FieldValue.arrayUnion(r)
                            });
                    }
                }).catch(async (error) => {
                    this.$toast.open({message: 'Unable to load survey', type: "error"});
                    throw new Error("Unable to load survey:  " + error.message);
                })
        },
        async openPreliminaryQuestions() {
            const surveyResult = this.surveyResult;

            await this.checkIfResident();

            if (this.survey?.isPreliminaryQuestions && this.isResident) {
                this.dialog = true;
            }

            if (surveyResult && Object.prototype.hasOwnProperty.call(surveyResult, 'isHappy')) {
                this.preliminaryQuestions.isHappy = surveyResult?.isHappy;
            }

            if (surveyResult && Object.prototype.hasOwnProperty.call(surveyResult, 'assistantType')) {
                this.preliminaryQuestions.assistantType = surveyResult?.assistantType;
            }
        },
        async checkIfResident() {
            const id = this.$route.params.r;
            if(id) {
                await firebase
                  .firestore()
                  .collection("residents")
                  .doc(id)
                  .get()
                  .then((data) => {
                      const resident = serializer.documentSnapshotToDocument(data);
                      if (!resident.id) {
                          this.isResident = false;
                      }
                  }).catch(() => {
                      this.isResident = false;
                  })
            }
        },
        async completePreliminaryQuestion() {
            this.loadingForm = true;

            if (this.preliminaryQuestions.assistantType === "none") {
                this.preliminaryQuestions.isAssistant = false;
            }

            await firebase
                .firestore()
                .collection("surveyResults")
                .doc(this.surveyResult.id)
                .update({
                    ...this.preliminaryQuestions
                }).then((data) => {
                    this.loadingForm = false;
                    this.dialog = false;
                }).catch(error => {
                    alert("COMPLETE PRELIMINARY QUESTION ERROR " + error.message)
                })
        },
    },
};
